import React from 'react';

export const SYMBOL_IDS = [
    'burger', 'hotdog', 'fries', 'shake', 'skull',
    'pumpkin', 'bat', 'eye', 'spider',
    'wild', 'scatter', 'jackpot', 'wheel',
];

const SLOT_ART = `${process.env.PUBLIC_URL}/img/games/habburgersslots`;

export const IMAGE_SYMBOLS = {
    burger:  { src: `${SLOT_ART}/symbol_1.png`, native: 16, pixel: true },
    hotdog:  { src: `${SLOT_ART}/symbol_2.png`, native: 16, pixel: true },
    fries:   { src: `${SLOT_ART}/symbol_3.png`, native: 16, pixel: true },
    shake:   { src: `${SLOT_ART}/symbol_4.png`, native: 16, pixel: true },
    skull:   { src: `${SLOT_ART}/symbol_5.png`, native: 16, pixel: true },
    pumpkin: { src: `${SLOT_ART}/symbol_6.png`, native: 16, pixel: true },
    bat:     { src: `${SLOT_ART}/symbol_7.png`, native: 16, pixel: true },
    eye:     { src: `${SLOT_ART}/symbol_8.png`, native: 16, pixel: true },
    spider:  { src: `${SLOT_ART}/symbol_9.png`, native: 16, pixel: true },
    blank:   { src: `${SLOT_ART}/symbol_blank.png`, native: 16, pixel: true },
    wild:    { src: `${SLOT_ART}/symbol_wild.png`, native: 16, pixel: true },
    scatter: { src: `${SLOT_ART}/symbol_fs.png`, native: 16, pixel: true },
    jackpot: { src: `${process.env.PUBLIC_URL}/img/stampcard_stamp.png`, native: 66, pixel: false },
};

export const PIXEL_BASE = 16;

// Pixel art may only ever be drawn at a whole-number multiple of its native
// size, so work out the largest whole multiple that still fits the cell.
export function pixelScaleFor(cellPx, native = PIXEL_BASE, fill = 0.78) {
    return Math.max(1, Math.floor((cellPx * fill) / native));
}

export const SYMBOL_NAMES = {
    burger:  'Slime Burger',
    hotdog:  'Slime Hotdog',
    pumpkin: 'Frank o Lantern',
    bat:     'Rubber Bat',
    skull:   'Sugar Skull',
    fries:   'Slime Fries',
    shake:   'Slime Shake',
    eye:     'Pickled Eyeball',
    spider:  'Cellar Spider',
    wild:    'Wild',
    scatter: 'Free Spins',
    blank:   'Slime Splat',
    jackpot: 'Framp Stamp',
    wheel:   'Slime Wheel',
};

export const SYMBOL_TIERS = {
    burger: 'high', hotdog: 'high', fries: 'high', shake: 'high', skull: 'high',
    pumpkin: 'low', bat: 'low', eye: 'low', spider: 'low',
    wild: 'wild', scatter: 'scatter', blank: 'blank', jackpot: 'jackpot', wheel: 'wheel',
};

export const SYMBOL_TINTS = {
    burger:  '#8ddc3b',
    hotdog:  '#4cb63a',
    pumpkin: '#ff8a1e',
    bat:     '#a06bff',
    skull:   '#f2ecd8',
    fries:   '#c3f53d',
    shake:   '#6df35e',
    eye:     '#ff5d6c',
    spider:  '#9aa5b5',
    wild:    '#4dff88',
    scatter: '#ffa04a',
    blank:   '#2b3a2f',
    jackpot: '#ffd24a',
    wheel:   '#89cff0',
};

const GLYPHS = {
    burger: (
        <g>
            <path d="M10 24c0-8 10-14 22-14s22 6 22 14z" fill="#d99a4e" />
            <path d="M14 20c1.5-1.5 3-1.5 4.5 0M28 15c1.5-1.5 3-1.5 4.5 0M42 19c1.5-1.5 3-1.5 4.5 0" stroke="#f4d9a8" strokeWidth="2" strokeLinecap="round" fill="none" />
            <rect x="9" y="24" width="46" height="6" rx="3" fill="#6fbf2f" />
            <path d="M9 30h46v5c0 3-2 5-5 5H14c-3 0-5-2-5-5z" fill="#8a4b2a" />
            <path d="M11 40c4 3 8 1 12 3s8 2 12 0 8-4 12-2 6 1 6 1v3c0 4-4 7-9 7H20c-5 0-9-3-9-7z" fill="#d99a4e" />
            <path d="M12 30c3 6 7 9 12 10M30 31c1 6 4 9 9 11" stroke="#a6ee55" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.9" />
        </g>
    ),
    hotdog: (
        <g>
            <path d="M14 30c0-10 8-18 18-18s18 8 18 18v22l-6-5-6 5-6-5-6 5-6-5-6 5z" fill="#e8f4ff" />
            <ellipse cx="25" cy="29" rx="4" ry="5.5" fill="#1a1030" />
            <ellipse cx="39" cy="29" rx="4" ry="5.5" fill="#1a1030" />
            <path d="M28 40c2 3 6 3 8 0" stroke="#1a1030" strokeWidth="2.5" strokeLinecap="round" fill="none" />
            <path d="M18 22c1-4 4-7 8-8" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.8" />
        </g>
    ),
    pumpkin: (
        <g>
            <path d="M30 12c0-4 2-6 5-6" stroke="#4f7a2a" strokeWidth="4" strokeLinecap="round" fill="none" />
            <rect x="28" y="10" width="7" height="7" rx="2" fill="#5e8f31" />
            <ellipse cx="32" cy="38" rx="24" ry="20" fill="#f07c14" />
            <ellipse cx="20" cy="38" rx="9" ry="20" fill="#d96a0c" opacity="0.5" />
            <ellipse cx="44" cy="38" rx="9" ry="20" fill="#d96a0c" opacity="0.5" />
            <path d="M18 32l8-4 2 7z" fill="#2b1405" />
            <path d="M46 32l-8-4-2 7z" fill="#2b1405" />
            <path d="M20 44h24l-4 6h-4l-3-4-3 4h-4z" fill="#2b1405" />
        </g>
    ),
    bat: (
        <g>
            <path d="M32 26c3 0 5 2 5 5v9c0 3-2 5-5 5s-5-2-5-5v-9c0-3 2-5 5-5z" fill="#3a2258" />
            <path d="M27 28C21 21 13 19 5 21c4 3 5 7 4 11 4-2 7-1 9 2 2-4 5-5 9-6z" fill="#5b3a8c" />
            <path d="M37 28c6-7 14-9 22-7-4 3-5 7-4 11-4-2-7-1-9 2-2-4-5-5-9-6z" fill="#5b3a8c" />
            <path d="M28 20l2 5h4l2-5-4 3z" fill="#3a2258" />
            <circle cx="29" cy="32" r="2" fill="#ff4d6d" />
            <circle cx="35" cy="32" r="2" fill="#ff4d6d" />
        </g>
    ),
    skull: (
        <g>
            <path d="M32 8c12 0 20 8 20 19 0 7-3 11-6 14v7c0 3-2 5-5 5H23c-3 0-5-2-5-5v-7c-3-3-6-7-6-14C12 16 20 8 32 8z" fill="#f4efe0" />
            <ellipse cx="23" cy="28" rx="6" ry="7" fill="#241a33" />
            <ellipse cx="41" cy="28" rx="6" ry="7" fill="#241a33" />
            <path d="M32 34l-3.5 7h7z" fill="#241a33" />
            <path d="M25 46v6M32 46v6M39 46v6" stroke="#241a33" strokeWidth="2.5" strokeLinecap="round" />
            <circle cx="23" cy="28" r="2" fill="#7bf07b" />
            <circle cx="41" cy="28" r="2" fill="#7bf07b" />
        </g>
    ),
    fries: (
        <g>
            <path d="M18 26l4-16 4 1-3 15zM26 24l2-17 4 1-1 16zM34 24l2-16 4 1-2 15zM42 26l4-15 4 2-4 14z" fill="#ffd24a" stroke="#e0a92c" strokeWidth="1.5" strokeLinejoin="round" />
            <path d="M14 24h36l-3 26c-.3 3-2.6 5-5.6 5H22.6c-3 0-5.3-2-5.6-5z" fill="#d8342b" />
            <path d="M14 24h36l-1 8H15z" fill="#f0463c" />
            <path d="M20 22c4 5 9 6 14 4s9-3 12 0" stroke="#8ddc3b" strokeWidth="3" strokeLinecap="round" fill="none" />
        </g>
    ),
    shake: (
        <g>
            <path d="M18 22h28l-4 32c-.3 3-2.6 5-5.5 5h-9c-2.9 0-5.2-2-5.5-5z" fill="#f2f6f8" />
            <path d="M18 22h28l-1 7H19z" fill="#d7e2e8" />
            <path d="M16 20c0-6 7-10 16-10s16 4 16 10z" fill="#7de2c3" />
            <path d="M16 20c3-2 5 1 8-1s5 2 8 0 5 2 8 0 5 2 8 1" stroke="#4fc9a4" strokeWidth="3" strokeLinecap="round" fill="none" />
            <rect x="36" y="4" width="4" height="18" rx="2" transform="rotate(12 38 13)" fill="#ff5d6c" />
            <circle cx="27" cy="14" r="3" fill="#4fc9a4" />
        </g>
    ),
    eye: (
        <g>
            <circle cx="32" cy="32" r="22" fill="#f6f1e4" />
            <circle cx="32" cy="32" r="22" fill="none" stroke="#cbbfa4" strokeWidth="2" />
            <circle cx="32" cy="32" r="11" fill="#3fa9c9" />
            <circle cx="32" cy="32" r="5" fill="#12202c" />
            <circle cx="28" cy="28" r="2.5" fill="#ffffff" opacity="0.9" />
            <path d="M12 26c5 2 8 4 10 7M52 26c-5 2-8 4-10 7M14 42c6-1 9-3 11-6M50 42c-6-1-9-3-11-6" stroke="#d8453f" strokeWidth="2" strokeLinecap="round" fill="none" />
        </g>
    ),
    spider: (
        <g>
            <path d="M20 20L6 12M20 30H4M21 40L8 48M44 20l14-8M44 30h16M43 40l13 8" stroke="#2f3846" strokeWidth="3" strokeLinecap="round" fill="none" />
            <ellipse cx="32" cy="36" rx="14" ry="16" fill="#28303d" />
            <circle cx="32" cy="21" r="9" fill="#39434f" />
            <circle cx="28" cy="20" r="2.5" fill="#ff4d6d" />
            <circle cx="36" cy="20" r="2.5" fill="#ff4d6d" />
            <path d="M32 12v-8" stroke="#2f3846" strokeWidth="2" strokeLinecap="round" />
        </g>
    ),
    wild: (
        <g>
            <path d="M32 6c14 0 24 9 24 21 0 14-11 20-11 27 0 3-3 4-13 4s-13-1-13-4c0-7-11-13-11-27C8 15 18 6 32 6z" fill="#3ddc6f" />
            <path d="M32 6c14 0 24 9 24 21 0 14-11 20-11 27 0 3-3 4-13 4s-13-1-13-4c0-7-11-13-11-27C8 15 18 6 32 6z" fill="none" stroke="#8bffb0" strokeWidth="2" />
            <ellipse cx="24" cy="26" rx="5" ry="6" fill="#0d2417" />
            <ellipse cx="40" cy="26" rx="5" ry="6" fill="#0d2417" />
            <circle cx="22" cy="24" r="2" fill="#ffffff" />
            <circle cx="38" cy="24" r="2" fill="#ffffff" />
            <path d="M24 38c4 5 12 5 16 0" stroke="#0d2417" strokeWidth="3" strokeLinecap="round" fill="none" />
            <path d="M18 14c3-3 6-4 9-4" stroke="#c4ffd6" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.8" />
        </g>
    ),
    blank: (
        <g opacity="0.55">
            <path d="M20 40c-6 0-10-4-10-9s3-8 7-10c0-6 5-11 11-11 4 0 8 2 10 6 1-.5 2-.7 3-.7 5 0 9 4 9 9 0 1 0 2-.4 3 3 1.4 5 4.4 5 7.7 0 5-4 9-9 9z" fill="#2f4438" />
            <circle cx="22" cy="47" r="3" fill="#2f4438" />
            <circle cx="33" cy="50" r="2" fill="#2f4438" />
            <circle cx="43" cy="46" r="2.5" fill="#2f4438" />
        </g>
    ),
    wheel: (
        <g>
            <circle cx="32" cy="35" r="24" fill="#0d1a2a" stroke="#89cff0" strokeWidth="3" />
            <path d="M32 35 L32 11 A24 24 0 0 1 52.8 23z" fill="#89cff0" opacity="0.85" />
            <path d="M32 35 L52.8 47 A24 24 0 0 1 32 59z" fill="#6df35e" opacity="0.85" />
            <path d="M32 35 L11.2 23 A24 24 0 0 1 32 11z" fill="#ffd24a" opacity="0.85" />
            <path d="M32 35 L11.2 47 A24 24 0 0 0 32 59z" fill="#4dc9ff" opacity="0.85" />
            <path d="M32 35 L52.8 23 A24 24 0 0 1 52.8 47z" fill="#ffffff" opacity="0.35" />
            <path d="M32 35 L11.2 47 A24 24 0 0 1 11.2 23z" fill="#ffffff" opacity="0.2" />
            <circle cx="32" cy="35" r="5" fill="#0d1a2a" stroke="#89cff0" strokeWidth="2.5" />
            <path d="M32 2l5 9H27z" fill="#89cff0" />
        </g>
    ),
    scatter: (
        <g>
            <rect x="6" y="14" width="52" height="30" rx="5" fill="#1b0d2a" stroke="#ff3fb4" strokeWidth="3" />
            <path d="M14 24h8M14 30h8M14 36h6" stroke="#ff3fb4" strokeWidth="3" strokeLinecap="round" />
            <path d="M28 36V24l6 7 6-7v12" stroke="#4dffd0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            <path d="M46 24h6M46 30h5M46 36h6" stroke="#ffd24a" strokeWidth="3" strokeLinecap="round" />
            <path d="M18 44v8M46 44v8" stroke="#5b3a8c" strokeWidth="3" strokeLinecap="round" />
            <circle cx="32" cy="55" r="2" fill="#ff3fb4" />
        </g>
    ),
};

export default function SlotSymbol({ id, size = 48, cellPx = 0, pixelScale = 0, dim = false, style }) {
    const art = IMAGE_SYMBOLS[id];
    if (art) {
        let px;
        if (art.pixel) {
            const scale = pixelScale > 0
                ? Math.max(1, Math.round(pixelScale))
                : pixelScaleFor(cellPx || (typeof size === 'number' ? size / 0.78 : 64), art.native);
            px = art.native * scale;
        } else if (pixelScale > 0) {
            px = art.native;
        } else {
            const target = cellPx ? cellPx * 0.78 : (typeof size === 'number' ? size : 48);
            px = Math.min(art.native, Math.round(target));
        }

        return (
            <img
                src={art.src}
                alt={SYMBOL_NAMES[id] || id}
                draggable={false}
                style={{
                    display: 'block',
                    width: px,
                    height: px,
                    imageRendering: 'pixelated',
                    opacity: dim ? 0.32 : 1,
                    filter: dim ? 'grayscale(0.7)' : `drop-shadow(0 0 7px ${SYMBOL_TINTS[id]}aa)`,
                    transition: 'opacity 0.18s ease, filter 0.18s ease',
                    ...style,
                }}
            />
        );
    }

    const glyph = GLYPHS[id];
    if (!glyph) return null;
    return (
        <svg
            viewBox="0 0 64 64"
            width={size}
            height={size}
            aria-label={SYMBOL_NAMES[id] || id}
            role="img"
            style={{
                display: 'block',
                opacity: dim ? 0.32 : 1,
                filter: dim ? 'grayscale(0.7)' : `drop-shadow(0 0 6px ${SYMBOL_TINTS[id]}55)`,
                transition: 'opacity 0.18s ease, filter 0.18s ease',
                ...style,
            }}
        >
            {glyph}
        </svg>
    );
}
